// Validação e formatação de CPF
export class CPFValidator {
  // Remove caracteres não numéricos
  static cleanCPF(cpf) {
    return cpf.replace(/\D/g, '');
  }

  // Formata CPF com máscara (000.000.000-00)
  static formatCPF(cpf) {
    const cleaned = this.cleanCPF(cpf);
    if (cleaned.length === 0) return '';
    
    // Limita a 11 dígitos
    const limited = cleaned.slice(0, 11);
    
    // Aplica máscara
    if (limited.length <= 3) return limited;
    if (limited.length <= 6) return `${limited.slice(0, 3)}.${limited.slice(3)}`;
    if (limited.length <= 9) return `${limited.slice(0, 3)}.${limited.slice(3, 6)}.${limited.slice(6)}`;
    return `${limited.slice(0, 3)}.${limited.slice(3, 6)}.${limited.slice(6, 9)}-${limited.slice(9)}`;
  }

  // Valida se o CPF é válido (algoritmo oficial)
  static isValidCPF(cpf) {
    const cleaned = this.cleanCPF(cpf);
    
    // Verifica se tem 11 dígitos
    if (cleaned.length !== 11) return false;
    
    // Verifica se todos os dígitos são iguais (CPF inválido)
    if (/^(\d)\1{10}$/.test(cleaned)) return false;
    
    // Validação do primeiro dígito verificador
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cleaned.charAt(i)) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cleaned.charAt(9))) return false;
    
    // Validação do segundo dígito verificador
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cleaned.charAt(i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cleaned.charAt(10))) return false;
    
    return true;
  }

  // Valida CPF formatado (com máscara)
  static isValidFormattedCPF(cpf) {
    // Verifica formato
    const formatRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
    if (!formatRegex.test(cpf)) return false;
    
    // Valida conteúdo
    return this.isValidCPF(cpf);
  }

  // Retorna CPF formatado se válido, ou string vazia se inválido
  static getValidFormattedCPF(cpf) {
    if (this.isValidCPF(cpf)) {
      return this.formatCPF(cpf);
    }
    return '';
  }

  // Validação em tempo real para inputs
  static validateInput(input) {
    const cleaned = this.cleanCPF(input);
    
    // Se vazio, permite
    if (cleaned.length === 0) return { isValid: true, message: '' };
    
    // Se menos de 11 dígitos, ainda está digitando
    if (cleaned.length < 11) return { isValid: true, message: 'Digite o CPF completo' };
    
    // Se exatamente 11 dígitos, valida
    if (cleaned.length === 11) {
      if (this.isValidCPF(cleaned)) {
        return { isValid: true, message: 'CPF válido' };
      } else {
        return { isValid: false, message: 'CPF inválido' };
      }
    }
    
    // Se mais de 11 dígitos, inválido
    return { isValid: false, message: 'CPF deve ter 11 dígitos' };
  }
}

export default CPFValidator;
























